import { defineStore } from 'pinia'
import { useCmsFetch } from '@/composables/craft-fetch'
import { useCacheStore } from '~/store/cache'

export const ignoreShelterSiteHandles = Object.freeze(['winschoten', 'zuidwolde'])

export const useShelterStore = defineStore('shelter', () => {
  const cacheStore = useCacheStore()
  const cmsFetch = useCmsFetch()

  const shelter = ref(undefined)

  async function fetchShelter({ site, push }: { site: string; push: boolean }) {
    const key = `shelter;site:${site}`
    const ttl = 3600

    const fetcher = async () => {
      const options = ignoreShelterSiteHandles.includes(site) ? { notFoundStrategy: 'ignore' } : {}
      return await cmsFetch(`/api/site/${site}/shelter.json`, options)
    }

    const shelter_ = await cacheStore.fetch({ key, ttl, fetcher })

    if (push) {
      shelter.value = shelter_
    }

    return shelter_
  }

  return { shelter, fetch: fetchShelter }
})
